import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Table from '@ui/Table'

import { getUsersHeaders } from '@models/admin/tenantUsers'
import DeleteDialog from '@ui/DeleteDialog'
import styles from '@styles/indexPage'

class Index extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isDialogOpen: false,
      id: null
    }

    this.closeDialog = this.closeDialog.bind(this)
  }

  closeDialog() {
    this.setState({ isDialogOpen: false })
  }

  render() {
    const { model, classes, tenant, o } = this.props
    const { isDialogOpen, id } = this.state

    return (
      <Paper className={classes.page__wrapper} elevation={0}>
        <header className={classes.page__header}>
          <Typography component='h2' variant='h5'>
            {I18n.t('v4/tenant.members.title')}
          </Typography>
        </header>
        <Button
          variant='outlined'
          color='primary'
          className={classes.page__newResourceButton}
          href={`/v4/o/${o}/admin/tenants/${tenant.id}/users/new`}
        >
          {I18n.t('v4/users.invite')}
        </Button>

        <Table
          tableKey='admin-tenants-users-index'
          components={{
            Container: props => <div>{props.children}</div>,
          }}
          columns={getUsersHeaders()}
          data={model}
          actions={[
            rowData => ({
              icon: 'create',
              iconProps: { 'data-testid': `edit-${rowData.id}` },
              tooltip: I18n.t('actions.edit'),
              onClick: (event, rowData) => {
                Turbolinks.visit(`/v4/o/${o}/admin/tenants/${tenant.id}/users/${rowData.id}/edit`)
              }
            }),
            rowData => ({
              icon: 'delete',
              iconProps: { 'data-testid': `delete-${rowData.id}` },
              tooltip: I18n.t('actions.remove'),
              onClick: (event, rowData) => {
                this.setState({ isDialogOpen: true, id: rowData.id })
              }
            }),
            rowData => ({
              icon: 'remove_red_eye',
              iconProps: { 'data-testid': `show-${rowData.id}` },
              tooltip: I18n.t('actions.view'),
              onClick: (event, rowData) => {
                Turbolinks.visit(`/v4/o/${o}/admin/tenants/${tenant.id}/users/${rowData.id}`)
              }
            })
          ]}
          options={{
            showTitle: false
          }}
        />

        <DeleteDialog
          dialogTitle={`${I18n.t('actions.remove')} ${I18n.t('activerecord.models.v4/users.one')}?`}
          dialogText={I18n.t('v4/users.confirmation.remove_from_tenant')}
          successUrl={`/v4/o/${o}/admin/tenants/${tenant.id}/users/`}
          deleteUrl={`/v4/o/${o}/admin/tenants/${tenant.id}/users/${id}`}
          onCancel={this.closeDialog}
          onClose={this.closeDialog}
          open={isDialogOpen}
        />
      </Paper>
    )
  }
}

Index.defaultProps = {
  tenant: {},
  model: []
}

Index.propTypes = {
  model: PropTypes.array
}

export default withStyles(styles)(Index)
